export const READ_DELIVERY_TRACKING = 199000;